import client from 'lib/api/client';

export const getNotificationList = ({ page }) =>
  client.get(`/notification?page=${page}&limit=10`);

export const updateNotification = ({ id }) =>
  client.post(`/notification/${id}`, null, {
    headers: {
      'X-Method-Override': 'PATCH',
    },
  });
